import { createRouter, createWebHistory } from "vue-router";
import { state } from "./store";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", component: () => import("./views/Login.vue") },
    {
      path: "/",
      component: () => import("./views/Layout.vue"),
      children: [
        { path: "", redirect: "/vouchers" },
        { path: "vouchers", component: () => import("./views/Vouchers.vue") },
        { path: "vouchers/new", component: () => import("./views/VoucherEdit.vue") },
        { path: "vouchers/:id", component: () => import("./views/VoucherEdit.vue") },
        { path: "vouchers/:id/print", component: () => import("./views/VoucherPrint.vue") },
        { path: "ledgers", component: () => import("./views/Ledgers.vue") },
        { path: "reports", component: () => import("./views/Reports.vue") },
        { path: "cashier", component: () => import("./views/Cashier.vue") },
        { path: "inventory", component: () => import("./views/Inventory.vue") },
        { path: "pro", component: () => import("./views/ProModules.vue") },
        { path: "closing", component: () => import("./views/Closing.vue") },
        { path: "admin", component: () => import("./views/Admin.vue") },
      ],
    },
  ],
});

router.beforeEach((to) => {
  if (to.path !== "/login" && !state.token) return "/login";
  if (to.path === "/login" && state.token) return "/vouchers";
});

export default router;
